module.exports = __webpack_public_path__ + "static/media/sign.ae87095e.svg";